import { useEffect, useState, useRef } from "react";
import React from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import { AiOutlineProject } from "react-icons/ai";
import {
  MdAssignmentInd,
  MdDelete,
  MdOutlineLowPriority,
  MdPreview,
} from "react-icons/md";
import { BiTask } from "react-icons/bi";
import { BsTextParagraph } from "react-icons/bs";
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import { TextField, MenuItem } from "@mui/material"; //for modal textfield
import { DateRangePicker } from "react-date-range"; //for daterangepicker
import "react-date-range/dist/styles.css"; // Main CSS file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
import { enUS } from "date-fns/locale"; // Import locale data
import { FaCalendarAlt, FaFileUpload } from "react-icons/fa";
import { InputAdornment } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { BsListCheck } from "react-icons/bs";
import dayjs from "dayjs";
import { CiWarning } from "react-icons/ci";
import { MdDashboard } from "react-icons/md";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slider,
} from "@mui/material";


const TaskPage = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true); //loader
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [project, setProject] = useState([]);
  const [employee, setEmployees] = useState([]);
  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const [deleteServiceName, setDeleteServiceName] = useState("");
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [errors, setErrors] = useState({}); //error show state
  const [filteredTask, setFilteredTasks] = useState([]); // For search functionality
  const [showDatePicker, setShowDatePicker] = useState(false); //open calender on click  
  // const [subtask, setSubTasks] = useState([]);
  const [dateRange, setDateRange] = useState([
    //daterange
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [subtaskData, setSubtaskData] = useState(null); // State to store subtask data
  const [isProgressModalOpen, setIsProgressModalOpen] = useState(false); // Modal open state
  //This is for File uploading
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const userData = JSON.parse(localStorage.getItem("user")); //get id from local storage
  const userId = userData.id;
  const userRole = userData.role;
  const [DescriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [progress, setProgress] = useState(0);
  const [comment, setComment] = useState("");
  const [prevTasks, setPrevTasks] = useState([]);

  const handleOpenReplyModal = (subtask) => {
    console.log("Opening Reply Modal for Subtask:", subtask);
    if (!subtask.task_update_id) {
      toast.error("Error: Subtask is missing!");
      console.error("Error: Subtask ID (task_update_id) is missing!");
      return;
    }
    setSelectedSubtask(subtask);  // Store the selected subtask correctly
    setProgress(subtask.task_progress || 0);
    setComment(subtask.task_comment || "");
    setIsReplyModalOpen(true);
  };
  //set data
  const [formData, setFormData] = useState({
    project_task_project_id: "",
    project_task_assignto: [],
    project_task_assignby: userId,
    project_task_priority: "",
    project_task_title: "",
    project_task_Description: "",
    project_task_duration: "",
    project_task_isstart: "",
    project_task_iscompleted: "",
    project_task_isactive: true, //by default set
    project_task_status: "Pending", //by default set
    project_task_attach_file: "",
  });
  const [editMode, setEditMode] = useState(false); // Edit mode flag
  // Fetch employees, managers, team leader data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      console.log("response------->", response.data.employees.employee_role);
      // Filter both employees and managers
      const employeeData = response.data.employees
        // Include both roles
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
          Role: emp.employee_role, // Include role for reference
        }));
      console.log("employeeData--->", employeeData);
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleSelect = (ranges) => {
    const selectedRange = ranges.selection;
    setDateRange([selectedRange]);
    // Create the taskDuration payload
    const taskDuration = {
      startDate: selectedRange.startDate.toISOString(), // Convert to ISO string
      endDate: selectedRange.endDate.toISOString(), // Convert to ISO string
    };
    console.log("Task Duration Payload:", taskDuration);
  };

  // Fetch Project data from the API
  const fetchProject = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/projects"
      );
      const projectData = response.data.project.map((project) => ({
        ProjectId: project.project_id,
        ProjectName: project.project_name,
      }));
      console.log("project-->", projectData.ProjectName);
      setProject(projectData);
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProject();
  }, []);

  //featch Task data from the API
  // Fetch Task data and map with project and employee data
  const fetchTasks = async () => {
    setLoading(true);
    try {
      let taskUrl;
      // if (userData.role == "admin") {
      taskUrl = `https://aligndesk.dropyourbusiness.com/api/tasks`;
      // } else {
      //   taskUrl = `https://aligndesk.dropyourbusiness.com/api/project-tasks/assigner/${userId}`;
      // }
      // Fetch task data
      const response = await axios.get(taskUrl);
      const taskData = response.data.task.map((t) => ({
        TaskId: t.project_task_id,
        ProjectId: t.project_task_project_id,
        TaskAssignTo: t.project_task_assignto,
        TaskAssignBy: t.project_task_assignby,
        Priority: t.project_task_priority,
        TaskTitle: t.project_task_title,
        TaskDescription: t.project_task_Description,
        TaskDuration: t.project_task_duration,
        TaskIsStart: t.project_task_isstart,
        TaskIsCompleted: t.project_task_iscompleted,
        TaskIsActive: t.project_task_isactive,
        TaskStatus: t.project_task_status,
        TaskFile: t.project_task_attach_file,
      }));
      console.log("taskDatas--->", taskData);
      // Fetch project data
      const projectResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/projects"
      );
      const projectData = projectResponse.data.project;
      // Fetch employee data
      const employeeResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      const employeeData = employeeResponse.data.employees;
      // Map task data with project and employee details
      const taskDataWithDetails = taskData.map((task) => {
        // Find the corresponding project
        const project = projectData.find(
          (proj) => proj.project_id === task.ProjectId
        );
        // Find the corresponding employee
        const employee = employeeData.find(
          (emp) => emp.employee_id === task.TaskAssignTo
        );
        // console.log("employeeemployeeemployee-->", employee.employee_role);
        if (!employee) {
          console.error(
            `No employee found for TaskAssignTo: ${task.TaskAssignTo}`
          );
        } 
        
         // Display toast notification based on TaskStatus
        //    toast.info(
        //   `Task "${task.TaskTitle}" status updated to "${task.TaskStatus}"`,
        //   {
        //     position: "top-right",
        //     // autoClose: 3000,
        //     hideProgressBar: false,
        //     // closeOnClick: true,
        //     // pauseOnHover: true,
        //     // draggable: true,
        //   }
        // );    
        
        // Return enriched task data
        return {
          ...task,
          ProjectName: project ? project.project_name : "Unknown Project",
          EmployeeName: employee
            ? `${employee.employee_first_name} ${employee.employee_last_name}`
            : "Unknown Employee",
        };
      });
            
      // Update tasks state with the enriched data
      setTasks(taskDataWithDetails);
      setFilteredTasks(taskDataWithDetails);
    } catch (error) {
      console.error("Error fetching task, project or employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTasks();
  }, []);


  
  // Handle file selection
  const handleFileChange = (info) => {
    let files = info.fileList.map((file) => file.originFileObj || file);
    setFileList(files);
  };

  //Handle remove file
  const handleRemoveFile = (fileToRemove) => {
    setFileList((prevFiles) =>
      prevFiles.filter((file) => file !== fileToRemove)
    );
    if (previewImage === URL.createObjectURL(fileToRemove.originFileObj)) {
      setPreviewImage(""); // Clear preview if removed
    }
  };

  // Handle file preview
  const handlePreview = async (file) => {
    let previewUrl =
      file.url ||
      (file.originFileObj ? URL.createObjectURL(file.originFileObj) : null);
    if (previewUrl) {
      setPreviewImage(previewUrl);
      setPreviewVisible(true);
      setPreviewTitle(file.name || "File Preview");
    } else {
      console.error("Invalid file for preview:", file);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  //open modal
  const openModal = (taskData = null) => {
    if (taskData) {
      setFormData(taskData);
      setEditMode(true);
    } else {
      setFormData({
        project_task_project_id: "",
        project_task_assignto: [],
        // project_task_assignto: "",
        project_task_assignby: userId,
        project_task_priority: "",
        project_task_title: "",
        project_task_Description: "",
        project_task_duration: "",
        project_task_isstart: "",
        project_task_iscompleted: "",
        project_task_isactive: true, //by default set
        project_task_status: "Pending", //by default set
        project_task_attach_file: "",
      });
      setEditMode(false);
    }
    // Reset validation errors
    setErrors({});
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  //date-range
  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    setDateRange([selection]);
    setFormData({
      ...formData,
      project_task_duration: `${dayjs(selection.startDate).format(
        "DD-MM-YYYY"
      )} - ${dayjs(selection.endDate).format("DD-MM-YYYY")}`, // Save as formatted date range
    });
    setShowDatePicker(false); // Hide the date picker after selecting a range
  };
  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker); // Toggle date picker visibility
  };

  //edit
  const handleEdit = (t) => {
    setFormData({
      project_task_id: t.TaskId,
      project_task_project_id: t.ProjectId,
      project_task_assignto: t.TaskAssignTo || "",
      project_task_assignby: t.TaskAssignBy,
      project_task_priority: t.Priority || "",
      project_task_title: t.TaskTitle || "",
      project_task_Description: t.TaskDescription || "",
      project_task_duration: t.TaskDuration || "",
      project_task_isstart: t.TaskIsStart || "",
      project_task_iscompleted: t.TaskIsCompleted || "",
      project_task_isactive: t.TaskIsActive || "",
      project_task_status: t.TaskStatus || "",
      project_task_attach_file: t.TaskFile || "",
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };

  //delete
  // Handle delete action, set task name and ID
  const handleDelete = async (t) => {
    const task_id = t.TaskId;
    const task_name = t.TaskTitle;
    if (!task_id) {
      toast.error("Invalid task ID. Please try again.");
      return;
    }
    // Set task name and ID to state before showing the pop-up
    setDeleteServiceName(task_name); // Dynamically sets the task name
    setDeleteServiceId(task_id); // Dynamically sets the task ID
    setShowDeleteBox(true); // Show the confirmation popup
  };
  // Confirm delete action
  const confirmDelete = async () => {
    if (!deleteServiceId) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/task/delete/${deleteServiceId}`
      );
      if (response.status === 200) {
        toast.success("Task deleted successfully!");
        const updatedTasks = tasks.filter(
          (item) => item.TaskId !== deleteServiceId
        );
        setTasks(updatedTasks);
        setFilteredTasks(updatedTasks);
      }
      setShowDeleteBox(false); // Close the confirmation box after deletion
    } catch (error) {
      console.error("Error deleting Task:", error);
      toast.error("An error occurred while deleting the Task.");
      setShowDeleteBox(false); // Close the box on error
    }
  };
  // Cancel delete action
  const cancelDelete = () => {
    setShowDeleteBox(false); // Close the confirmation box without deleting
  };
  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit--->");
    // Validate the form
    const validateForm = () => {
      const newErrors = {};
      if (!formData.project_task_title) {
        newErrors.project_task_title = "Task Title is required.";
      }
      if (!formData.project_task_assignto) {
        newErrors.project_task_assignto = "Employee Name is required.";
      }
      if (!formData.project_task_priority) {
        newErrors.project_task_priority = "Priority is required.";
      }
      if (!formData.project_task_duration) {
        newErrors.project_task_duration = "Task Duration is required.";
      }
      if (!formData.project_task_project_id) {
        newErrors.project_task_project_id = "Project Name is required.";
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    // Check for duplicates only when adding a new task
    if (!editMode) {
      const isTitleExists = tasks.some(
        (task) =>
          task.TaskTitle.toLowerCase() ===
          formData.project_task_title.toLowerCase()
      );
      const isProjectExists = tasks.some(
        (task) => task.ProjectId === formData.project_task_project_id
      );
      const isEmployeeAssigned = tasks.some(
        (task) => task.TaskAssignTo === formData.project_task_assignto
      );
    }
    try {
      const url = editMode
        ? `https://aligndesk.dropyourbusiness.com/api/task/update/${formData.project_task_id}`
        : "https://aligndesk.dropyourbusiness.com/api/task/add";
      const method = editMode ? "put" : "post";
      // Send API request
      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode ? "Task updated successfully!" : "Task added successfully!"
      );
      fetchTasks(); // Refresh task list
      closeModal();
      setErrors({});
    } catch (error) {
      console.error("Error submitting task data:", error);
      toast.error("Failed to submit data. Please try again.");
    }
  };

  //for upload file attachment in task
  const handleFileUpload = async (taskId, file) => {
    if (!file) {
      toast.error("Please select a file.");
      return;
    }
    const formData = new FormData();
    formData.append("project_task_attach_file", file);
    setLoading(true);
    try {
      const response = await axios.post(
        `https://aligndesk.dropyourbusiness.com/api/task/add-attachment/${taskId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchTasks(); // Refresh tasks after upload
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File Type Must Be: pdf, doc, docx, xlsx, csv, txt, png, jpg, jpeg");
    }
  };
  //function for delete the file
  const handleFileDelete = async (t) => {
    const task_id = t.TaskId;
    if (!task_id) {
      toast.error("Invalid task ID. Please try again.");
      return;
    }
    const confirmed = window.confirm(
      "Are you sure you want to delete this task File?"
    );
    if (!confirmed) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/task/delete-attachment/${task_id}`
      );
      console.log("response", response);
      if (response.status === 200 || response.status === 201) {
        // Remove the deleted tasks from the state
        toast.success("Task File deleted successfully!");
        console.log("success delete");
        fetchTasks();
      }
    } catch (error) {
      console.error("Error deleting Task:", error);
      toast.error("An error occurred while deleting the Task.");
    }
  };

  //Handle Progress for showing a progress data in modal
  const handleProgress = async (project_task_id) => {
    console.log("Fetching progress for TaskId:", project_task_id);
    // setLoading(true);
    try {
      const response = await fetch(
        `https://aligndesk.dropyourbusiness.com/api/subtasks/projecttask/${project_task_id.TaskId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch progress data");
      }
      const data = await response.json();
      if (response.status === 200 || response.status === 201) {
        setSubtaskData(data); // Reverse the fetched data before setting state
        setIsProgressModalOpen(true); // Open the modal
      } else {
        toast.error("No progress data available for this task.");
      }
    } catch (err) {
      toast.warn("No progress data available for this task.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // Function to handle status update
  const handleStatusChange = async (taskId, newStatus) => {
    if (!newStatus) {
      toast.error("Invalid status update");
      return;
    }
    try {
      const response = await axios.put(
        `https://aligndesk.dropyourbusiness.com/api/task/${taskId}/status`,
        { project_task_status: newStatus },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success("Task status updated successfully!");
        // fetchTasks(); // Refresh task list after update
      } else {
        toast.error("Failed to update task status.");
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Error updating task status.");
    }
  }; useEffect(() => {
    const fetchSubtasks = async () => {
      try {
        const response = await fetch("https://aligndesk.dropyourbusiness.com/api/subtasks");
        if (!response.ok) {
          throw new Error("Failed to fetch subtasks");
        }
        const data = await response.json();
        console.log("Fetched Subtasks:", data); // Debugging
        setSubtaskData(data); // Update state with fetched data
      } catch (error) {
        console.error("Error fetching subtasks:", error);
      }
    };
    fetchSubtasks();
  }, []);

  const handleReplySubmit = async () => {
    console.log("Selected Subtask in handleReplySubmit:", selectedSubtask);
    // Retrieve logged-in user details (Modify this based on how authentication is handled)
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    // Ensure a subtask is selected
    if (!selectedSubtask) {
      console.error("Error: No subtask selected!");
      return;
    }
    // Extract subtask ID
    const subtaskId = selectedSubtask.task_update_id;
    if (!subtaskId) {
      toast.error("Error: No valid subtask ID found! Cannot update.");
      console.error("Error: No valid subtask ID found! Cannot update.");
      return;
    }
    // Prepare data for update
    const updatedData = {
      task_Updateby: loggedInUser.id,  // Dynamically set the logged-in user ID
      task_ptm_id: selectedSubtask.task_ptm_id,
      task_progress: String(progress), 
      task_comment: comment.trim(),
      task_isactive: true,
      task_attach_file: null,
      task_created_at: selectedSubtask.task_created_at,
      task_updated_at: new Date().toISOString(),
  };

    try {
      console.log(`Updating Subtask ID: ${subtaskId}`);
      console.log("Payload being sent:", updatedData);
      const response = await fetch(
        `https://aligndesk.dropyourbusiness.com/api/subtask/update/${subtaskId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        }
      );
      console.log("Response Status:", response.status);
      const responseText = await response.text();
      console.log("Response Body:", responseText);
      if (!response.ok) {
        throw new Error("Failed to update subtask");
      }
      const result = JSON.parse(responseText);
      toast.success("Subtask updated successfully");
      console.log("Subtask updated successfully:", result);
      // Close modal on success
      setIsReplyModalOpen(false);
    } catch (error) {
      toast.error("Error Updating Subtask");
      console.error("Error updating subtask:", error);
    }
  }; 
  
  //Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    { Header: "Title", accessor: "TaskTitle" },
    {
      Header: "Description",
      accessor: "TaskDescription",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => {
        const fullDescription = `${row.original.TaskDescription}`;
        const truncatedDescription =
          fullDescription.length > 15
            ? `${fullDescription.substring(0, 15)}...`
            : fullDescription;
        return (
          <>
            <span>{truncatedDescription}</span>
            {fullDescription.length > 15 && (
              <Button
                size="small"
                color="primary"
                onClick={() => {
                  setSelectedDescription(fullDescription);
                  setDescriptionDialogOpen(true);
                }}
              >
                See More
              </Button>
            )}
          </>
        );
      },
    },
    { Header: "Project", accessor: "ProjectName" },
    {
      Header: "Employee",
      accessor: "EmployeeName",
      Cell: ({ row }) => `${row.original.EmployeeName}`,
    },
    { Header: "Duration", accessor: "TaskDuration" },
    {
      Header: "Priority",
      accessor: "Priority",
      Cell: ({ value }) => (
        <span
          style={{
            color:
              value === "High"
                ? "#e74c3c"
                : value === "Medium"
                  ? "#f39c12"
                  : value === "Low"
                    ? "#27ae60"
                    : "black", // Default color
            fontWeight: "bold",
          }}
        >
          {value}
        </span>
      ),
    },
    {
      Header: "Status",
      accessor: "TaskStatus",
      Cell: ({ row }) => {
        const [status, setStatus] = useState(row.original.TaskStatus);
        const [showDropdown, setShowDropdown] = useState(false);
        const handleDropdownChange = (newStatus) => {
          setStatus(newStatus);
          handleStatusChange(row.original.TaskId, newStatus);
          setShowDropdown(false); // Close dropdown after selection
        };
        return (
          <div
            style={{ position: "relative", cursor: "pointer" }}
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <span
              className="status-badge"
              style={{
                color: "white",
                background:
                  status === "Pending"
                    ? "#fd9696" // Soft red
                    : status === "Ongoing"
                      ? "#FFA726" // Soft Orange
                      : status === "InReview"
                        ? "#42A5F5" // Soft Blue
                        : status === "Completed"
                          ? "#66BB6A" // Soft Green
                          : "#FFA726", // Soft Gray
                fontWeight: "bold",
                borderRadius: "10px",
                padding: "5px",
                cursor: "pointer",
                display: "inline-block",
                transition: "all 0.3s ease-in-out",
              }}
            >
              {status}
            </span>
            {showDropdown && (
              <div
                className="dropdown-menu"
                style={{
                  position: "absolute",
                  background: "#fff",
                  border: "1px solid #ddd",
                  padding: "5px",
                  marginLeft: "65px",
                  marginTop: "-85px",
                  borderRadius: "5px",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  zIndex: 100,
                }}
              >
                {["Ongoing","Completed"].map((option) => (
                  <div
                    key={option}
                    style={{
                      padding: "5px",
                      cursor: "pointer",
                      background: option === status ? "#f0f0f0" : "white",
                    }}
                    onClick={() => handleDropdownChange(option)}
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "File",
      accessor: "TaskFile",
      Cell: ({ row }) => {
        const [isHovered, setIsHovered] = useState(false);
        const hasFile = !!row.original.TaskFile; // Check if file exists
        return (
          <div
            className="file-cell"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* If no file, show upload option */}
            {!hasFile ? (
              <>
                <label
                  htmlFor={`file-upload-${row.original.TaskId}`}
                  className="file-upload-label"
                >
                  <FaFileUpload className="file-icon" />
                </label>
                <input
                  type="file"
                  id={`file-upload-${row.original.TaskId}`}
                  style={{ display: "none" }}
                  onChange={(e) =>
                    handleFileUpload(row.original.TaskId, e.target.files[0])
                  }
                />
              </>
            ) : (
              <>
                {/* Show Preview Icon */}
                <MdPreview className="file-icon" />
                {/* Show options on hover */}
                {isHovered && (
                  <div className="file-hover-options">
                    <a
                      href={row.original.TaskFile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-option"
                    >
                      <MdPreview className="file-icon" />
                      Preview
                    </a>
                    <button
                      onClick={() => handleFileDelete(row.original)}
                      className="file-delete-button"
                    >
                      <MdDelete className="file-icon" />
                      Delete
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];
  const hasAccess = (allowedRoles) => {
    const userRole = localStorage.getItem("role");
    return allowedRoles.includes(userRole);
  };
  return (
    <div>      
      <ToastContainer />
      {loading}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <BsListCheck /> Task
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>
      {/* //For progress modal show  */}
      <Modal
        isOpen={isProgressModalOpen}
        onRequestClose={() => setIsProgressModalOpen(false)}
        contentLabel="Task Progress"
        className="progress-modal"
        shouldCloseOnOverlayClick={true}
      >
        <div className="progress-modal-content">
          <h2 className="progress-modal-title">Task Progress</h2>
          {subtaskData ? (
            <div className="progress-modal-data">
              <table className="progress-table" style={{ border: "none" }}>
                <thead>
                  <tr>
                    <th>Updated Date</th>
                    <th>Progress</th>
                    <th>Comment</th>
                    <th>File</th>
                    <th>Reply</th> {/* Added Reply column */}
                  </tr>
                </thead>
                <tbody>
                {subtaskData.subtasks.slice().reverse().map((subtask, index) =>  (
                    <tr key={index}>
                      <td>{subtask.task_updated_at}</td>
                      <td>{subtask.task_progress}%</td>
                      <td>{subtask.task_comment}</td>
                      <td>
                        {subtask.task_attach_file && (
                          <img
                            src="../images/file.png"
                            alt="Open File"
                            className="open-file-icon"
                            onClick={() =>
                              window.open(subtask.task_attach_file, "_blank")
                            }
                          />
                        )}
                      </td>
                      <td>
                        {/* Added Reply button to open reply modal */}
                        <button onClick={() => handleOpenReplyModal(subtask)}>Reply</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="loading-text">Loading task progress...</p>
          )}
          <button
            className="close-button"
            onClick={() => setIsProgressModalOpen(false)}
          >
            Close
          </button>
        </div>
      </Modal>
      {/* modal for reply subtask  */}
      <Modal
        isOpen={isReplyModalOpen}
        onRequestClose={() => setIsReplyModalOpen(false)}
        contentLabel="Update Progress"
        className="reply-modal"
      >
        <div className="reply-modal-content">
          <div className="reply-modal-progress">
          <h2>Update Progress</h2>
          <Slider
            value={progress}
            onChange={(e, val) => setProgress(val)}
            min={0}
            max={100}
            step={10}
            valueLabelDisplay="auto"
          />
          <Typography>Progress: {progress}%</Typography>
          </div>
          <div className="reply-bodal-comment">
          <TextField
            label="Task Comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            fullWidth
          />
          </div>
          <div className="reply-modal-btn">
          <button className="reply-submit-button" onClick={handleReplySubmit}>
            Submit
          </button>
          <button className="reply-close-button" onClick={() => setIsReplyModalOpen(false)}>
            Cancel
          </button>
          </div>
        </div>
      </Modal>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredTask.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleProgress={handleProgress}
          isTaskProgress={true}
          isDeleteAction={userRole === "admin"} // Only show delete action for admin
          isEditAction={true}         
        />
      )}
      {/* Address */}
      <Dialog
        open={DescriptionDialogOpen}
        onClose={() => setDescriptionDialogOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6">Description</Typography>
          <Typography variant="body2">{selectedDescription}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDescriptionDialogOpen(false)} style={{backgroundColor:"red",color:"white"}}>Close</Button>
        </DialogActions>
      </Dialog>
      {/* Custom Delete Confirmation Box */}
      {showDeleteBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the task{" "}
              <span className="task-name">
                <strong>{deleteServiceName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDelete} // Trigger confirmDelete
              >
                Yes, Delete
              </button>
              <button
                className="cancel-button"
                onClick={cancelDelete} // Trigger cancelDelete
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal} //other click on screen, never close form modal
        contentLabel="Task Form"
        className="add-task-modal"
        shouldCloseOnOverlayClick={false}
        style={{
          content: {
            width: "380px",
          },
        }}
      >
        <h2>{editMode ? "Edit Task" : "Add Task"}</h2>
        <form className="task-form" onSubmit={handleSubmit}>
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  label="Task Title"
                  name="project_task_title"
                  value={formData.project_task_title}
                  error={!!errors.project_task_title}
                  helperText={errors.project_task_title}
                  onChange={handleInputChange}
                  style={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <BiTask />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="form-field">
                <TextField
                  select
                  label="Project Name"
                  name="project_task_project_id"
                  value={formData.project_task_project_id}
                  error={!!errors.project_task_project_id}
                  helperText={errors.project_task_project_id}
                  onChange={handleInputChange}
                  // disabled={editMode} //Disable when editing
                  fullWidth
                  style={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <AiOutlineProject />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Project</MenuItem>
                  {project.map((project) => (
                    <MenuItem key={project.ProjectId} value={project.ProjectId}>
                      {project.ProjectName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            {/* Row 2 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  select
                  label="Assign To"
                  name="project_task_assignto"
                  value={formData.project_task_assignto}
                  error={!!errors.project_task_assignto}
                  helperText={errors.project_task_assignto}
                  onChange={handleInputChange}
                  // disabled={editMode} //Disable when editing
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdAssignmentInd />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Employee</MenuItem>
                  {employee
                    .filter((emp) => {
                      if (userRole === "manager") {
                        return emp.Role !== "M"; // Hide "Manager" role for managers
                      } else if (userRole === "Team Leader") {
                        return emp.Role !== "T" && emp.Role !== "M";
                      }
                      return true; // Show all roles for other users (admin)
                    })
                    .map((employees) => (
                      <MenuItem
                        key={employees.Employee_id}
                        value={employees.Employee_id}
                      >
                        {employees.EmployeeName} - {employees.Role}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
              <div className="form-field">
                <TextField
                  select
                  label="Priority"
                  name="project_task_priority"
                  value={formData.project_task_priority}
                  error={!!errors.project_task_priority}
                  helperText={errors.project_task_priority}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdOutlineLowPriority />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem>Select Priority</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </TextField>
              </div>
            </div>
            {/* Row 3 */}
            <div className="form-row">
              <div className="form-field">
                {/* Input Field with Calendar Icon */}
                <TextField
                  label="Task Duration"
                  name="project_task_duration"
                  value={formData.project_task_duration}
                  error={!!errors.project_task_duration}
                  helperText={errors.project_task_duration}
                  onClick={toggleDatePicker} // Open date picker on click
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaCalendarAlt
                          onClick={toggleDatePicker}
                          style={{ cursor: "pointer" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  readOnly // Make the input field readonly
                />
              </div>
              {/* Conditional Rendering of DateRangePicker */}
              {showDatePicker && (
                <div
                  style={{
                    position: "absolute",
                    marginLeft: "380px",
                    marginTop: "-300px",
                  }}
                >
                  <DateRangePicker
                    ranges={dateRange}
                    onChange={handleDateRangeChange}
                    locale={enUS}
                    moveRangeOnFirstSelection={false}
                  />
                </div>
              )}
            </div>
            {/* Row 4 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  label="Description"
                  name="project_task_Description"
                  id="outlined-textarea"
                  value={formData.project_task_Description}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  rows={1} // You can adjust the number of rows as needed
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <BsTextParagraph />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="all-button-form">
            <button type="submit">{editMode ? "Edit" : "+Add"}</button>
            <button type="button" onClick={closeModal} className="close-button">
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default TaskPage;